import { contentApi } from '../../utils/urls';
import { enqueueSnackbar } from 'notistack';
import i18next from 'i18next';
import { rootApi } from '../../services/rootApi';

export const globalApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    saveDataForObject: builder.mutation({
      query: ({ objectId, objectType, data }) => ({
        url: contentApi(),
        method: 'POST',
        body: {
          data: {
            data,
            objectId,
            objectType
          },
          method: 'saveDataForObject'
        }
      }),
      invalidatesTags: ['Content'],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          enqueueSnackbar(i18next.t('notifications.dataSaved'), { variant: 'success' });
        } catch (error) {
          enqueueSnackbar(i18next.t('notifications.errorSavingData'), { variant: 'error' });
        }
      }
    })
  }),
  overrideExisting: false,
});

export const { useSaveDataForObjectMutation } = globalApiSlice;